import { render, staticRenderFns } from "./g-conflict-part-modal.vue?vue&type=template&id=1aaf0a02&scoped=true&"
import script from "./g-conflict-part-modal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./g-conflict-part-modal.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./g-conflict-part-modal.vue?vue&type=style&index=0&id=1aaf0a02&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaf0a02",
  null
  
)

export default component.exports